<template>
  <portal to="sidebar-menu">
    <div>
      <slot name="before"></slot>
      <nav-list :items="navigationItems"></nav-list>
      <slot name="after"></slot>
    </div>
  </portal>
</template>
<script>

  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'

  export default {
    name: 'candidates-left-menu',
    data () {
      return {
        navigationItems: [
          {
            type: 'group',
            name: this.$t('sidebar.links.candidates')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CANDIDATE),
            name: this.$t('sidebar.links.candidates')
          },
          {
            type: 'group',
            name: this.$t('jobAlerts.menu.title')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.JOB_ALERT),
            name: this.$t('jobAlerts.menu.title')
          },
          {
            type: 'group',
            name: this.$t('sidebar.links.applicants')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.APPLICANTS),
            name: this.$t('sidebar.links.applicants')
          },
          {
            routeName: 'applicants_check_list',
            name: this.$t('sidebar.links.applicantsToCheck')
          },
          {
            type: 'group',
            name: this.$t('sidebar.links.resumes')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.RESUME),
            name: this.$t('sidebar.links.resumes')
          }
        ]
      }
    }
  }
</script>
<style>
</style>
